import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const talSample: IMcAppType = {
  name: "talSample",
  path: "/my/tal-sample-app",
  description: "Tal Sample App",
  navFlow: NavFlow.STANDARD,
  title: "Message Us",
  parent: Tab.MORE,
  conditions: {
    intent: "talSample",
    customerType: CustomerType.kraken,
  },
};
